import React, { useEffect } from "react";
import UserScreenWindow from "../Components/UserScreenWindow";
import { useSelector } from "react-redux";
import FacilityCard from "./FacilityCard";
import { Link } from "react-router-dom";
import { getAllDocsSnap } from "../../../utils/firebase/Firebase.utils";
import { FaBuilding } from "react-icons/fa";

export default function FacilitiesUser() {
  const currentUser = useSelector((state) => state.userObject);
  const [facilities, setFacilities] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    const fetchFacilities = async () => {
      await getAllDocsSnap("facilities", (data) => {
        setFacilities(data);
        setLoading(false);
      });
    };
    fetchFacilities();
  }, []);

  if (loading) {
    return <UserScreenWindow>Loading...</UserScreenWindow>;
  }

  return (
    <UserScreenWindow label="Facilities">
      <div className="w-full mx-auto px-4 max-w-4xl">
        <div className="flex items-center justify-between mb-6 bg-[#363062]/5 p-4 rounded-lg">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-[#363062] rounded-lg">
              <FaBuilding className="text-white text-base" />
            </div>
            <div>
              <h1 className="text-sm font-medium text-[#363062]">
                Facilities Booking
              </h1>
              <p className="text-xs text-gray-500">
                Browse and manage your facility bookings
              </p>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          {facilities.map((facility, index) => (
            <Link
              to={`/user/facilities/${facility.id}`}
              key={index}
              className="block transition-all hover:transform hover:translate-y-[-2px] hover:shadow-md"
            >
              <div className="cursor-pointer p-2">
                <FacilityCard data={facility} />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </UserScreenWindow>
  );
}